import React from "react";
import { BannerParentDiv } from "./Banner.styled";

const Banner = () => {
  return (
    <div>
      <BannerParentDiv>
        <h1>Pakistan Tourism Corporation</h1>
      </BannerParentDiv>
    </div>
  );
};

export default Banner;
